import React from 'react';
import { ChatMessage } from '@nxsys/store/slices/message/types';
import { Icons } from '@nxsys/types/icons';

type MessageTicksProps = {
  message: ChatMessage;
  maxOtherReadAt: string | null;
};

const MessageTicks: React.FC<MessageTicksProps> = ({
  message,
  maxOtherReadAt,
}) => {
  const msgDate = message.createdAt ? new Date(message.createdAt) : null;
  const readDate = maxOtherReadAt ? new Date(maxOtherReadAt) : null;
  const isReadByOther = !!(msgDate && readDate && msgDate <= readDate);

  // Blue double tick: read by others
  if (isReadByOther) {
    return (
      <span className="chat-bubble-ticks" title="Read">
        <Icons.IconDoubleTick color="#34b7f1" />
      </span>
    );
  }

  // Delivered: 2 gray ticks
  if (message._status === 'delivered') {
    return (
      <span className="chat-bubble-ticks" title="Delivered">
        <Icons.IconDoubleTick color="#b0b0b0" />
      </span>
    );
  }

  // Sent: 1 gray tick
  if (message._status === 'sent') {
    return (
      <span className="chat-bubble-ticks" title="Sent">
        <Icons.IconSingleTick color="#b0b0b0" />
      </span>
    );
  }

  // Sending: no icon
  if (message._status === 'sending') {
    return null;
  }

  // Server messages without _status (historical): show as delivered
  if (message.id && !message._status) {
    if (isReadByOther) {
      return (
        <span className="chat-bubble-ticks" title="Read">
          <Icons.IconDoubleTick color="#34b7f1" />
        </span>
      );
    }
    return (
      <span className="chat-bubble-ticks" title="Delivered">
        <Icons.IconDoubleTick color="#b0b0b0" />
      </span>
    );
  }

  return null;
};

export default MessageTicks;
